'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdRingVolume = function MdRingVolume(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm10.7 16.3s-5.8-5.8-5.9-5.8l2.3-2.4 5.9 5.9z m10.9-12.9v8.2h-3.2v-8.2h3.2z m13.6 7.1c-0.1 0-5.9 5.8-5.9 5.8l-2.3-2.3 5.9-6z m4.3 17.3c0.3 0.3 0.5 0.7 0.5 1.2s-0.2 0.8-0.5 1.2l-4.1 4.1c-0.3 0.3-0.7 0.5-1.2 0.5s-0.8-0.2-1.2-0.5c-1.3-1.3-2.8-2.3-4.4-3.1-0.6-0.3-0.9-0.9-0.9-1.5v-5.2c-2.5-0.8-5-1.1-7.7-1.1s-5.2 0.3-7.7 1.1v5.2c0 0.7-0.3 1.3-0.9 1.6-1.6 0.7-3.1 1.7-4.4 3-0.4 0.3-0.7 0.5-1.2 0.5s-0.9-0.2-1.2-0.5l-4.1-4.1c-0.3-0.4-0.5-0.7-0.5-1.2s0.2-0.9 0.5-1.2c5.1-4.8 11.9-7.8 19.5-7.8s14.5 3 19.5 7.8z' })
        )
    );
};

exports.default = MdRingVolume;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/ring-volume.js
// module id = 1400
// module chunks = 36573943044255 79611799117203 213534597649335